import React from "react";
import Boton from "../Boton";

export default function InicioBanner() {
  return (
    <div className="flex flex-row m-5  " alt="ciudad" >
      <div className="mx-5 w-2/5">

         <img src="https://d1466nnw0ex81e.cloudfront.net/n_iv/600/848447.jpg" alt={"banner"}
        />
      </div>
      <div className="m-5 w-2/5">
        <h2 className="text-3xl font-semibold text-purple-700"> Electropolis </h2>
        <p className="xl">
          Dean Motter empezó a interesarse por el dibujo desde una edad muy
          temprana, y sus padres, ambos artistas, le animaron en su vocación.
          Empezó a cursar estudios universitarios de bellas artes, pero perdió
          interés y prefirió dedicarse a la música.​ A finales de los años 70,
          Motter fue editor y director artístico de Andromeda, una serie
          canadiense de cómics que adaptaba trabajos de autores importantes de
          ciencia-ficción, como Arthur C. Clarke y A.E. van Vogt. Durante este
          periodo, Motter y su colaborador Ken Steacy crearon The Sacred & The
          Profane (publicado en Star Reach), a la que Archie Goodwin se refirió
          como "la primera novela gráfica verdadera" en el mercado de los
          cómics.​ También colaboró en el diseño del libro póstumo de Marshall
          McLuhan, Laws of Media, e lustró varios libros educacionales para
          niños. Motter consiguió notoriedad por sus portadas para discos
          durante su estancia como director artístico de CBS Records Canada, y
          más tarde en sus propio estudio, Diagram Studios, y (tras el cierre de
          Diagram) Modern Imageworks. Sus portadas y dibujos promocionales
          (para artistas como The Nylons, Triumph, Loverboy, The Diodes, Liona
          Boyd, The Irish Rovers y Jane Siberry) han ganado varios premios.
          Motter ha sido nominado para el Premio Juno seis veces, y ha ganado
          dos: En 1983 al Mejor Diseño de un Álbum por su trabajo en el disco de
          Anvil Metal on Metal, y al año siguiente por el álbum Seamless, de The
          Nylons, junto a Jeff Jackson y Deborah Samuel. En 1988, co-escribió y
          dibujó la miniserie Shattered Visage para DC Comics, basada en la
          serie británica de TV, protagonizada por Patrick McGoohan, El
          Prisionero. Al año siguiente creó el logo y el diseño básico de
          portadas para la línea Piranha Press, publicada por DC.
        </p>
         <div className="m-5 w-2/5">  
        <Boton />
        <p className="text-md text-center">Electropolis Dean Motter</p>
        </div>      
      </div>
    </div>
  );
}
